var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachmentVertical = function SvgAttachmentVertical(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "attachment_vertical_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h17.454v17.454H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attachment_vertical_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.852 11.378q0 1.77-1.232 3.015-1.233 1.243-3.002 1.243t-3.005-1.243-1.236-3.015V4.839q0-1.258.874-2.14.875-.88 2.133-.88t2.133.88q.874.882.874 2.14v6.19q0 .737-.514 1.26a1.7 1.7 0 0 1-1.254.522q-.74 0-1.262-.518a1.71 1.71 0 0 1-.522-1.265V5.19q0-.231.156-.389a.53.53 0 0 1 .39-.156q.23 0 .388.156a.53.53 0 0 1 .156.39v5.838a.675.675 0 0 0 .686.692.675.675 0 0 0 .685-.692V4.832a1.92 1.92 0 0 0-.56-1.364 1.83 1.83 0 0 0-1.356-.559q-.805 0-1.36.562-.556.563-.556 1.368v6.539q-.012 1.32.912 2.243a3.05 3.05 0 0 0 2.24.925q1.3 0 2.21-.925.91-.924.931-2.243V5.189q0-.231.157-.389a.53.53 0 0 1 .39-.156q.23 0 .388.156a.53.53 0 0 1 .156.39z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentVertical);
export default ForwardRef;